import { z } from "zod";
export function isRealCalendarDate(value) {
    const [year, month, day] = value.split("-").map(Number);
    const date = new Date(Date.UTC(year ?? 0, (month ?? 1) - 1, day ?? 0));
    return (date.getUTCFullYear() === year &&
        date.getUTCMonth() === (month ?? 1) - 1 &&
        date.getUTCDate() === day);
}
/** A strict YYYY-MM-DD calendar date; rejects impossible dates like 2026-99-99. */
export function calendarDateString(label) {
    return z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, `${label} must be YYYY-MM-DD`)
        .refine(isRealCalendarDate, `${label} must be a real calendar date`);
}
//# sourceMappingURL=calendar-date.js.map